import { AlertTriangle } from '@untitledui/icons'
import { twMerge } from 'tailwind-merge'

/** The error the backend gives when a reset link has expired. */
export const TOKEN_EXPIRED_ERROR = 'token expired'

export interface TokenValidationErrorCopy {
    linkExpired: string
    /** For every other reason the link isn't valid. */
    linkInvalid: string
    /** The link to request a new reset link, when there is one. */
    resendEmail?: string
}

export interface TokenValidationErrorProps {
    /** The error the token validation rejected with. */
    error: string
    /** Where to request a new reset link. Without it, the copy says how to get a new link. */
    resetPasswordHref?: string
    copy: TokenValidationErrorCopy
    className?: string
}

/**
 * Says a password reset link can't be used, and links to requesting a new one when that's possible.
 */
const TokenValidationError = ({
    error,
    resetPasswordHref,
    copy,
    className,
}: TokenValidationErrorProps) => (
    <div className={twMerge('flex flex-col items-start gap-4', className)}>
        <p className="m-0 flex items-start gap-2">
            <AlertTriangle className="size-5 shrink-0 text-[#f79009]" />
            {error === TOKEN_EXPIRED_ERROR ? copy.linkExpired : copy.linkInvalid}
        </p>
        {resetPasswordHref && copy.resendEmail && (
            <a
                href={resetPasswordHref}
                className="font-bold text-[#5788ff] underline hover:text-[#10185a]">
                {copy.resendEmail}
            </a>
        )}
    </div>
)

export default TokenValidationError
